import gql from 'graphql-tag';

export default gql`
  mutation theaterSignUp(
    $email: String!
    $password: String!
    $name: String!
    $plan: String!,
    $type: String!,
    $facebook: String,
    $theaterName: String!,
    $country: String,
    $website: String,
    $address: String,
    $city: String,
    $biography: String
    $features: [TheaterFeatureInput]
    $images: [TheaterImageInput]
  ) {
    theaterSignup(
      email: $email
      password: $password
      name: $name,
      plan: $plan,
      type: $type,
      theaterName: $theaterName,
      country: $country,
      website: $website,
      facebook: $facebook,
      address: $address,
      city: $city,
      biography: $biography,
      features: $features
      images: $images
    ) {
      token
      user {
        id
        name
        type
        theater {
          id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/TheaterSignUp.js